'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('SimpleDialogFormCtrl', SimpleDialogFormCtrl);

  SimpleDialogFormCtrl.$inject = ['$scope', '$mdDialog', '$document', 'Labels', 'SimpleDialogFormService'];

  function SimpleDialogFormCtrl ($scope, $mdDialog, $document, Labels, SimpleDialogFormService) {

    const vm = this;

    vm.LABELS = Labels;

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.close = function () {
      $mdDialog.hide();
    };

    vm.save = function () {
      const formData = {};
      vm.options.fields.forEach(function (field) {
        switch (field.type) {
          case 'select':
            formData[field.key] = field.newValue.toString();
            break;
          case 'checkbox':
            formData[field.key] = !!vm.instance[field.key];
            break;
          default:
            formData[field.key] = vm.instance[field.key];
        }
      });
      vm.options.save(formData, vm.originalInstance)
        .then($mdDialog.hide);
    };

    // Backwards compatibility
    $scope.open = SimpleDialogFormService.open;
  }
})();
